import {
  type MessageLanguageSource,
  resolveMessageLanguage,
  type SupportedLanguage,
} from '@shared/core/localized-defaults'

export type MessageLanguageProfile = {
  message_language?: string | null
  default_country_code?: string | null
}

export type MessageLanguage = {
  language: SupportedLanguage
  source: MessageLanguageSource
  countryCode: string | null
}

/** The one place the app turns a profile into its effective client message language. */
export function resolveProfileMessageLanguage(
  profile: MessageLanguageProfile | null | undefined,
  templateLanguage?: string | null,
): MessageLanguage {
  const countryCode = profile?.default_country_code ?? null
  const { language, source } = resolveMessageLanguage(
    { messageLanguage: profile?.message_language, defaultCountryCode: countryCode },
    templateLanguage,
  )
  return { language, source, countryCode }
}
